<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-card
    class="mt-1"
    elevation="0"
  >
    <v-card-text>
      <h1>{{ address.lastName.trim() }} {{ address.firstName.trim() }}</h1>
      <p class="mt-2">
        {{ address.addressLine1 }}
        <template v-if="address.addressLine2">
          {{ address.addressLine2 }}<br>
        </template>

        {{ address.city }} {{ address.plz }}<br>
        <span class="font-weight-bold">{{ $t('emailAddress') }} </span>{{ address.email }}<br>
        <span class="font-weight-bold">{{ $t('telephone') }} </span>{{ address.tel }}<br>
        <span class="font-weight-bold">{{ $t('deliveryTime') }} </span>{{ address.date }} {{ address.time }}<br>
        {{ noteText }}
      </p>
      <!-- 快餐扫码单（POS-239）：桌号和线上单号不再写在备注里，单独显示，方便客服对单 -->
      <v-chip
        v-if="isQuickOrder && address.tableLabel"
        class="mr-2"
      >
        {{ $t('tableNumber') }} {{ address.tableLabel }}
      </v-chip>
      <v-chip
        v-if="isQuickOrder"
        class="mr-2"
      >
        Ref {{ externalId }}
      </v-chip>
      <v-chip v-if="address.deliveryMethod">
        {{ address.deliveryMethod }}
      </v-chip>
      <v-chip v-if="address.reason">
        {{ address.reason }}
      </v-chip>
    </v-card-text>
  </v-card>
</template>

<script>
const DefaultAddressInfo = {
  lastName: '',
  firstName: '',
  reason: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  plz: '',
  tel: '',
  email: '',
  date: '',
  time: '',
  note: '',
  deliveryMethod: ''
}
export default {
  name: 'AddressInfoBlock',
  props: {
    addressInfo: {
      type: Object,
      default: () => DefaultAddressInfo
    },
    // 订单的 externalId；快餐扫码单是 q_ 开头
    externalId: {
      type: String,
      default: ''
    }
  },
  // data: function () {
  //   return Object.assign({}, DefaultAddressInfo, this.addressInfo)
  // },
  computed: {
    address () {
      return Object.assign({}, DefaultAddressInfo, this.addressInfo)
    },
    isQuickOrder () {
      return typeof this.externalId === 'string' && this.externalId.startsWith('q_')
    },
    // 门店存备注时把换行存成了 <br>，这里按普通文本显示，换成「·」。
    // 快餐扫码老单里云端自动写的「QuickOrder q_… - Tisch …」那一行不显示，桌号和单号在下面的标签里（和收银 3.0 一样）
    noteText () {
      return String(this.address.note ?? '').split('<br>').map(s => s.trim())
        .filter(s => s && !(this.isQuickOrder && s.startsWith('QuickOrder q_')))
        .join(' · ')
    }
  }
}
</script>

<style scoped>

</style>
